import { AnalyticsEvent } from '../../core/AnalyticsEvent';
import { PromotionCollectionEventSchema } from '../../schemas/promo/PromotionCollectionEventSchema';
import { getConfigFor } from '../../../../utils/configService'
import { SPLIT_FEATURES } from '../../../../utils/constants/feature'
import { getCommonParams } from '../../utils/CommonParams'

export interface PromotionCollectionEventParams {
    BUSINESS_VERTICAL: string
    EVENT_CATEGORY: string
    PROMOTION_COLLECTION_NAME: string
    PROMOTION_COLLECTION_POSITION: number
    STORE_ID_DBP: string | null
    STORE_ID_SAP: string | null
    STORE: string | null
}

export class PromotionCollectionEvent extends AnalyticsEvent {
    constructor(isClicked: boolean, params: PromotionCollectionEventParams) {
        super(PromotionCollectionEventSchema(isClicked), ['segment']);
        const paramsWithCommon = { ...params, ...getCommonParams() }
        this.createEventObject(paramsWithCommon);
    }
}

export async function trackPromotionCollectionEvent(
    isClicked: boolean,
    params: PromotionCollectionEventParams
): Promise<void> {
  const config = getConfigFor(SPLIT_FEATURES.LEAP_CDP_RELEASE_TWO) || {}
  const { isEnabled = false } = config
  if (isEnabled) {
    new PromotionCollectionEvent(isClicked, params).track();
  }
}